import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useGetBuildFixtureNameFunc } from "~hooks/useGetBuildFixtureNameFunc.ts";
import type { FixtureResources, FixtureResponse } from "~types/fixture.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect.tsx";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  seasonId?: string;
};

const SelectFixture = ({ value, seasonId, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const buildFixtureNameFunc = useGetBuildFixtureNameFunc();

  const onConvertResponseIntoOptionsHandler = (response: FixtureResponse) => {
    const resources: FixtureResources | undefined = response.includes?.resources;

    return (response?.data || []).map((fixture) => ({
      value: fixture.fixtureId,
      label: buildFixtureNameFunc(fixture, resources),
    }));
  };

  const url = seasonId
    ? `${sport}/o/${organizationId}/seasons/${seasonId}/fixtures`
    : `${sport}/o/${organizationId}/fixtures`;

  return (
    <InfinitySelect<FixtureResponse>
      {...props}
      url={url}
      sortByFieldName="startTimeLocal"
      includes={["entities", "persons"]}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.FIXTURE}
      permissionOperation={PermissionOperations.READ}
      resetOptionsDependencies={[seasonId]}
    />
  );
};

export default SelectFixture;
